import { Button, DatePicker, message, Modal } from 'antd';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Item from '../../../components/Form/Item';
import axios from '../../../util/Api';

const InductionUpdate = ({ item, passport }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const history = useHistory();

  const formik = useFormik({
    initialValues: {
      induction_date: item.induction_date
    },
    onSubmit: (values, actions) => {
      const url = `/passport/induction-update`;
      const data = {
        id: item.id,
        date: values.induction_date
      };
      axios.post(url, data).then(resp => {
        console.log(resp.data);
        if (resp.data.success) {
          message.success("Tanggal induksi telah berhasil diperbarui");
          window.location.reload();
        } else {
          message.error("Gagal memperbarui tanggal induksi");
        }
      }).catch(err => {
        message.error("Gagal memperbarui tanggal induksi");
      });
    }
  });

  const handleOk = () => {
    formik.submitForm();
  }

  const handleCancel = () => {
    setIsModalVisible(false);
  }
  return (
    <>
      <Button type="primary" ghost size="small" onClick={() => setIsModalVisible(true)}>Edit Tanggal Induksi</Button>
      <Modal title="Update Tanggal Induksi" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} okButtonProps={{loading: formik.isSubmitting}}>
        <Item inline={false} name="Tanggal Induksi" required>
          <DatePicker
            onChange={(value) => {
              formik.setFieldValue("induction_date", value.format("YYYY-MM-DD"));
            }}
            style={{ width: "100%" }}
          />
        </Item>
      </Modal>
    </>
  );
}

export default InductionUpdate;